import React, { Fragment, useContext, useState } from 'react'
import { AppContext } from '../../context'
import Slide from '../ui/Slide'

import water from '../../assets/img/water.svg'
import electricity from '../../assets/img/electricity.svg'
import shower from '../../assets/img/shower.svg'
import toilet from '../../assets/img/toilet.svg'
import launderette from '../../assets/img/launderette.svg'
import wifi from '../../assets/img/wifi.svg'
import gas from '../../assets/img/gas.svg'
import fuel from '../../assets/img/fuel.svg'
import recycling from '../../assets/img/recycling.svg'
import wastepumpout from '../../assets/img/wastepumpout.svg'
import repairs from '../../assets/img/repairs.svg'
import storage from '../../assets/img/storage.svg'
import haulout from '../../assets/img/haulout.svg'
import provisions from '../../assets/img/provisions.svg'
import restaurant from '../../assets/img/restaurant.svg'
import airport from '../../assets/img/airport.svg'
import ferries from '../../assets/img/ferries.svg'
import train from '../../assets/img/train.svg'
import bus from '../../assets/img/bus.svg'
import carhire from '../../assets/img/carhire.svg'
import taxi from '../../assets/img/taxi.svg'
import atm from '../../assets/img/atm.svg'
import postoffice from '../../assets/img/postoffice.svg'
import security from '../../assets/img/security.svg'
import medical from '../../assets/img/medical.svg'
import portofentry from '../../assets/img/portofentry.svg'
import customs from '../../assets/img/customs.svg'
import chandlery from '../../assets/img/chandlery.svg'

export const filters = [
  {
    category: 'MARINA FACILITIES',
    items: [
      { imageSrc: water, label: 'Water', key: 'Water' },
      {
        imageSrc: electricity,
        label: 'Electricity (Inc. 220v)',
        key: 'Electricity' as const
      },
      /*    {
                                                                  imageSrc: electricity,
                                                                  label: 'Electricity (Inc. 380v)',
                                                                  key: 'Electricity380V' as const
                                                                },*/
      { imageSrc: shower, label: 'Shower', key: 'Shower' },
      { imageSrc: toilet, label: 'Toilet', key: 'Toilet' },
      {
        imageSrc: launderette,
        label: 'Laundrette',
        key: 'Laundrette' as const
      },
      { imageSrc: wifi, label: 'Wifi', key: 'Wifi' },
      { imageSrc: gas, label: 'Gas', key: 'Gas' },
      { imageSrc: fuel, label: 'Fuel', key: 'Fuel' },
      { imageSrc: recycling, label: 'Recycling', key: 'Recycling' },
      {
        imageSrc: wastepumpout,
        label: 'Waste Pump-Out',
        key: 'Waste Pump-Out' as const
      }
    ]
  },
  {
    category: 'BOATYARD/SUPPORT SERVICES',
    items: [
      { imageSrc: repairs, label: 'Repairs', key: 'Repairs' },
      { imageSrc: storage, label: 'Storage', key: 'Storage' },
      { imageSrc: haulout, label: 'Haul Out', key: 'Haul Out' }
    ]
  },
  {
    category: 'SHOPPING',
    items: [
      {
        imageSrc: provisions,
        label: 'Local Provisions',
        key: 'Local Provisions'
      },
      { imageSrc: chandlery, label: 'Chandlery', key: 'Chandlery' }
    ]
  },
  {
    category: 'EATING ASHORE',
    items: [
      {
        imageSrc: restaurant,
        label: 'Restaurants',
        key: 'Restaurants' as const
      }
    ]
  },
  {
    category: 'TRANSPORT LINKS',
    items: [
      { imageSrc: airport, label: 'Airport', key: 'Airport' },
      { imageSrc: ferries, label: 'Ferries', key: 'Ferries' },
      { imageSrc: train, label: 'Train', key: 'Train' },
      { imageSrc: bus, label: 'Bus', key: 'Bus' },
      { imageSrc: carhire, label: 'Car Hire', key: 'Car' },
      { imageSrc: taxi, label: 'Taxi', key: 'Taxi' }
    ]
  },
  {
    category: 'OTHER',
    items: [
      { imageSrc: atm, label: 'Bank', key: 'Bank' },
      { imageSrc: postoffice, label: 'Post Office', key: 'Post Office' },
      { imageSrc: security, label: 'Security', key: 'Security' },
      { imageSrc: medical, label: 'Medical', key: 'Medical' },
      { imageSrc: portofentry, label: 'Port Of Entry', key: 'PortOfEntry' },
      { imageSrc: customs, label: 'Customs', key: 'Customs' }
    ]
  }
]

interface Filters {
  [key: string]: boolean
}

const FilterPopover: React.FC = () => {
  const [hasBeenUsed, setHasBeenUsed] = useState(false)
  const [selectedFilters, setSelectedFilters] = useState<Filters>({
    Water: false,
    Electricity: false,
    Shower: false,
    Toilet: false,
    Launderette: false,
    WiFi: false,
    Gas: false,
    Fuel: false,
    Recycling: false,
    'Waste Pump-Out': false,
    Repairs: false,
    Storage: false,
    HaulOut: false,
    Chandlery: false,
    Provisions: false,
    Restaurants: false,
    Airport: false,
    Ferries: false,
    TrainStation: false,
    BusConnections: false,
    HireCars: false,
    Taxi: false,
    Bank: false,
    PostOffice: false,
    Security: false,
    Medical: false,
    'Port of Entry': false,
    Customs: false
  })
  const isButtonDisabled =
    !Object.values(selectedFilters).some(c => c) && !hasBeenUsed
  const { setPlacesSourceQuery, setUserGeneratedLocationsSourceQuery } =
    useContext(AppContext)

  const applyFilters = () => {
    let query = ''

    // Create query string with selected filters
    let i = 0
    for (let key in selectedFilters) {
      const value = selectedFilters[key]

      if (value) {
        query += `${i === 0 ? '' : ','}${key}`

        i++
      }
    }

    setPlacesSourceQuery(query)
    setHasBeenUsed(true)
  }

  return (
    <AppContext.Consumer>
      {({ activePopover, onTogglePopover }) => (
        <Slide
          isVisible={activePopover === 'filter'}
          id="filter-overlay"
          className="overlay overlay-left"
        >
          <div id="close" className="card-header">
            <a
              className="close-button btn-pill no-fill no-label"
              onClick={() => onTogglePopover('')}
            >
              <span className="material-icons">clear</span>
            </a>
          </div>
          <div className="panel-body">
            <form id="filters-form">
              <div id="filters-container" className="card-body">
                <h2>Filters</h2>
                {filters.map(category => (
                  <Fragment key={category.category}>
                    <span className="filter-category-title">
                      {category.category}
                    </span>
                    <div id="filter-list">
                      {category.items.map(item => {
                        const stateKey = item.key
                        return (
                          <Fragment key={item.key}>
                            <img
                              id={item.key?.toLocaleLowerCase()}
                              className="filter-image"
                              src={item.imageSrc}
                            />
                            <label className="filter-label" htmlFor={item.key}>
                              {item.label}
                            </label>
                            <input
                              className="filter-checkbox"
                              type="checkbox"
                              name={item.label}
                              checked={selectedFilters[stateKey]}
                              onChange={e =>
                                setSelectedFilters({
                                  ...selectedFilters,
                                  [stateKey]: e.target.checked
                                })
                              }
                            />
                            <br />
                          </Fragment>
                        )
                      })}
                    </div>
                  </Fragment>
                ))}
              </div>
            </form>
          </div>
          <div className="card-footer">
            <a
              className={`btn btn-secondary ${
                isButtonDisabled ? 'disabled' : ''
              }`}
              onClick={applyFilters}
            >
              Apply filters
            </a>
          </div>
        </Slide>
      )}
    </AppContext.Consumer>
  )
}

export default FilterPopover
